import { createIcon } from "/srv/www/bsky.vibed.software/current/node_modules/.pnpm/@oomfware+vite-plugin-svg-sprites@0.1.2_react@19.3.0_vite@8.3.3_@types+node@26.6.4_esbu_0ed9e0a290f0f209d0c4c64a23e2f5f4/node_modules/@oomfware/vite-plugin-svg-sprites/dist/runtime/react.mjs";

export default /*#__PURE__*/ createIcon(
	"0 0 24 24",
	"__SVG_SPRITE_ulG7poReZPot_NoUlwat__",
);
